import FormattedMessage from 'I18n/components/FormattedMessage';
import { PopoverBody, PopoverFooter } from 'foundations-components/transitional/components/Popover';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const GoToActionConfirmationPopoverContent = ({
  id,
  onSave,
  onCancel
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PopoverBody, {
      children: /*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.goToEditCanvas.saveConnectionPopover.message"
        })
      })
    }), /*#__PURE__*/_jsx(PopoverFooter, {
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: () => {
            onSave(id);
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.goToEditCanvas.saveConnectionPopover.doneLabel"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: () => {
            onCancel(id);
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.goToEditCanvas.saveConnectionPopover.cancelLabel"
          })
        })]
      })
    })]
  });
};
export default GoToActionConfirmationPopoverContent;